import React from 'react';
import { FillableSVGProps } from 'Src/types';

export default function AccountStatusIcon({ filled, ...props }: FillableSVGProps) {
  if (filled) {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
        <path d="M16.2002 5H7.7002V3C7.7002 2.2 8.4002 1.5 9.2002 1.5H14.7002C15.5002 1.5 16.2002 2.2 16.2002 3V5Z" fill="currentcolor" />
        <path d="M18.8 3H17.2V6H6.8V3H5.2C4 3 3 4 3 5.2V20.3C3 21.5 4 22.5 5.2 22.5H18.8C20 22.5 21 21.5 21 20.3V5.2C21 4 20 3 18.8 3ZM15.7 17.3H8.3C7.9 17.3 7.5 17 7.5 16.5C7.5 16 7.8 15.7 8.3 15.7H15.8C16.2 15.7 16.6 16 16.6 16.5C16.6 17 16.2 17.3 15.7 17.3ZM15.7 13.5H8.3C7.9 13.5 7.5 13.2 7.5 12.7C7.5 12.2 7.8 12 8.3 12H15.8C16.2 12 16.6 12.3 16.6 12.8C16.6 13.3 16.2 13.5 15.7 13.5ZM15.7 9.8H8.3C7.8 9.8 7.5 9.4 7.5 9C7.5 8.6 7.8 8.2 8.3 8.2H15.8C16.2 8.2 16.6 8.5 16.6 9C16.6 9.5 16.2 9.8 15.7 9.8Z" fill="currentcolor" />
      </svg>
    );
  }

  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
      <path d="M8.25 8.25C7.83579 8.25 7.5 8.58579 7.5 9C7.5 9.41421 7.83579 9.75 8.25 9.75H15.75C16.1642 9.75 16.5 9.41421 16.5 9C16.5 8.58579 16.1642 8.25 15.75 8.25H8.25Z" fill="currentcolor" />
      <path d="M7.5 12.75C7.5 12.3358 7.83579 12 8.25 12H15.75C16.1642 12 16.5 12.3358 16.5 12.75C16.5 13.1642 16.1642 13.5 15.75 13.5H8.25C7.83579 13.5 7.5 13.1642 7.5 12.75Z" fill="currentcolor" />
      <path d="M8.25 15.75C7.83579 15.75 7.5 16.0858 7.5 16.5C7.5 16.9142 7.83579 17.25 8.25 17.25H15.75C16.1642 17.25 16.5 16.9142 16.5 16.5C16.5 16.0858 16.1642 15.75 15.75 15.75H8.25Z" fill="currentcolor" />
      <path d="M6.75 3C6.75 2.17157 7.42157 1.5 8.25 1.5H15.75C16.5784 1.5 17.25 2.17157 17.25 3H18.75C19.9926 3 21 4.00736 21 5.25V20.25C21 21.4926 19.9926 22.5 18.75 22.5H5.25C4.00736 22.5 3 21.4926 3 20.25V5.25C3 4.00736 4.00736 3 5.25 3L6.75 3ZM6.75 6V4.5H5.25C4.83579 4.5 4.5 4.83579 4.5 5.25V20.25C4.5 20.6642 4.83579 21 5.25 21H18.75C19.1642 21 19.5 20.6642 19.5 20.25V5.25C19.5 4.83579 19.1642 4.5 18.75 4.5H17.25V6H6.75Z" fill="currentcolor" />
    </svg>
  );
}

AccountStatusIcon.defaultProps = {
  filled: false,
};
